"use client";
import { useState } from "react";

import { ArrowDownTrayIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";

import { ClickServer } from "shared-lib/clickserver";
import * as gtag from "shared-lib/gtag";
import {
  TRACKING_EVENTS,
  logStatsig,
  TRACKING_CATEGORIES,
} from "shared-lib/helpers/statsigFunctions";

import { getTitle } from "@/lib/helpers/brandFunctions";
import { downloadRecipe } from "@/lib/helpers/pdfFunctions";

export default function DownloadButton({
  recipe,
  className,
  iconClassName,
}: {
  recipe: Recipe;
  className?: string;
  iconClassName?: string;
}) {
  const [downloading, setDownloading] = useState(false);

  return (
    <button
      className={clsx(className, "cursor-pointer")}
      disabled={downloading}
      onClick={async () => {
        try {
          setDownloading(true);
          gtag.event({
            action: TRACKING_EVENTS.download_click,
            category: TRACKING_CATEGORIES.interaction,
            label: getTitle(recipe.title ?? ""),
          });
          logStatsig(TRACKING_EVENTS.download_click);
          ClickServer.track(TRACKING_EVENTS.download_click);
          await downloadRecipe(recipe);
        } catch (e) {
          console.info(e);
        } finally {
          setDownloading(false);
        }
      }}
    >
      <ArrowDownTrayIcon
        className={clsx(iconClassName, "mx-auto h-[90%] w-[90%]")}
      />
    </button>
  );
}
